export default {
  retrieveBusList(state, payload) {
    state.busList = [].concat(payload.busList)
  },
  deleteBus(state, payload) {
    state.busList.splice(payload.busInfo.index, 1);
  },
  goToPage(state, payload) {
    state.searchData = payload
  },
  getBusLayoutList(state, payload) {
    state.busLayoutList = payload.busLayoutList
  },

  getPlateList(state, payload) {
    state.plateList = payload.plateList
  },

  updateState (state, payload) {
    state.currentFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentPage = payload.page ? payload.page : null
  }
}
